module.exports = __webpack_public_path__ + "img/17d1957e877424ebc3de7001280615a6.png";